<template>
  <div class="identity-values-edit-form pb-3">
    <form @submit="handleSubmit">
      <div class="d-inline-flex p2 flex-wrap">
        <b-form-group label="First Name" class="mr-2">
          <b-form-input
            v-model="firstName"
            placeholder="first name"
            :state="firstNameValidation.getState(validate)"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="firstNameValidation.getState(validate)"
            >{{ firstNameValidation.errorMessage }}</b-form-invalid-feedback
          >
        </b-form-group>
        <b-form-group label="Middle Name" class="mr-2">
          <b-form-input
            v-model="middleName"
            placeholder="middle name"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Last Name">
          <b-form-input
            v-model="lastName"
            placeholder="last name"
            :state="lastNameValidation.getState(validate)"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="lastNameValidation.getState(validate)"
            >{{ lastNameValidation.errorMessage }}</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <b-form-group label="Email">
        <b-form-input
          v-model="email"
          placeholder="email"
          :state="emailValidation.getState(validate)"
        ></b-form-input>
        <b-form-invalid-feedback :state="emailValidation.getState(validate)">{{
          emailValidation.errorMessage
        }}</b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="primary">submit</b-button>
      <b-button variant="link" @click="handleCancel">cancel</b-button>
    </form>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback
} from "bootstrap-vue";
export const SaveEvent = "save-identity-event";
export const CancelEvent = "cancel-identity-event";
import { IsNotEmptyString, IsValidEmail } from "@/components/lib/Validation";

export const Events = {
  save: SaveEvent,
  cancel: CancelEvent
};

export default {
  name: "IdentityValuesEditForm",
  computed: {
    firstNameValidation() {
      return IsNotEmptyString(this.firstName);
    },
    lastNameValidation() {
      return IsNotEmptyString(this.lastName);
    },
    emailValidation() {
      return IsValidEmail(this.email);
    },
    hasValidationErrors() {
      let validationFields = [
        this.emailValidation,
        this.lastNameValidation,
        this.firstNameValidation
      ];
      return validationFields.some(x => true !== x.isValid);
    }
  },
  methods: {
    reset() {
      this.email = this.initialEmail;
      this.firstName = this.initialFirstName;
      this.middleName = this.initialMiddleName;
      this.lastName = this.initialLastName;
      this.validate = false;
    },
    getChangedValues() {
      let result = {};
      this.maybeAddValue(
        "firstName",
        this.initialFirstName,
        this.firstName,
        result
      );
      this.maybeAddValue(
        "middleName",
        this.initialMiddleName,
        this.middleName,
        result
      );
      this.maybeAddValue(
        "lastName",
        this.initialLastName,
        this.lastName,
        result
      );
      this.maybeAddValue("email", this.initialEmail, this.email, result);
      return result;
    },
    maybeAddValue(label, originalValue, newValue, container) {
      if (originalValue !== newValue) {
        container[label] = newValue;
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      // only continue if no validation errors
      this.$emit(this.events.save, this.getChangedValues());
    },
    handleCancel() {
      this.$emit(this.events.cancel);
    }
  },
  data() {
    return {
      validate: false,
      events: Events,
      firstName: this.initialFirstName,
      middleName: this.initialMiddleName,
      lastName: this.initialLastName,
      email: this.initialEmail
    };
  },
  props: {
    initialFirstName: String,
    initialMiddleName: String,
    initialLastName: String,
    initialEmail: String
  },
  components: { BFormGroup, BFormInput, BButton, BFormInvalidFeedback }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
